import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { THERAPISTS } from '../mock';

export default function TeamPreview({ limit = 4 }) {
  const list = THERAPISTS.slice(0, limit);
  return (
    <section className="section-pad" style={{ background: 'var(--warm-white)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-12 reveal">
          <div className="eyebrow mb-3">Our Team</div>
          <h2 className="section-title mb-3">A Team You Can <span className="text-[color:var(--dusty-rose)]">Trust</span></h2>
          <p className="text-[color:var(--taupe-gray)] max-w-xl mx-auto">Experienced. Compassionate. Dedicated to you.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 stagger">
          {list.map((t, i) => (
            <div key={t.slug} className="card-soft lift-card overflow-hidden group reveal-scale">
              <div className="aspect-[4/5] overflow-hidden bg-[color:var(--cream)] zoom-frame">
                <img src={t.photo} alt={t.name} className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <h3 className="font-serif-display text-lg text-[color:var(--deep-sage)] leading-tight font-bold">{t.name}</h3>
                <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--sage-dark)] mt-1">{t.credentials}</div>
                <p className="text-sm text-[color:var(--taupe-gray)] mt-3 leading-relaxed line-clamp-3">{t.bioShort}</p>
                <Link to={`/team/${t.slug}`} className="mt-4 inline-flex items-center gap-1.5 text-sm text-[color:var(--dusty-rose)] font-semibold group/link">
                  Meet {t.name.split(' ')[0]} <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover/link:translate-x-1" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/team" className="btn-primary">Meet the Whole Team <ArrowRight className="w-4 h-4" /></Link>
        </div>
      </div>
    </section>
  );
}
